module.exports = __webpack_public_path__ + "static/media/gliding.b780cae1.jpg";